import { useEffect } from 'react';
import { getNotificationToken } from '../../../../firebase';
import { useAppDispatch } from '../../../../store/hooks';
import { useDeleteNotificationMutation } from '../../../user/api/user-api';
import AuthGuard from '../../components/auth-guard/auth-guard';
import { logout } from '../../store/auth-slice';

const Logout = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const [deleteNotificationToken] = useDeleteNotificationMutation();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        const token = await getNotificationToken();
        if (token) {
          await deleteNotificationToken(token);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error during token deletion:', error);
      } finally {
        dispatch(logout());
      }
    };

    handleLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthGuard>
      <></>
    </AuthGuard>
  );
};

export default Logout;
